import { render, staticRenderFns } from "./CrudTable.vue?vue&type=template&id=1f2d5d54&scoped=true&"
import script from "./CrudTable.vue?vue&type=script&lang=ts&"
export * from "./CrudTable.vue?vue&type=script&lang=ts&"
import style0 from "./CrudTable.vue?vue&type=style&index=0&id=1f2d5d54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2d5d54",
  null
  
)

export default component.exports